function Footer() {
    const links = [
        // { icon: "/images/footer/Telegram.png", name: "Telegram", link: "" },
        {
            icon: "/images/footer/Whatsapp.webp",
            name: "Whatsapp",
            link: "https://wa.me/+201067137563",
        },
        {
            icon: "/images/footer/Tiktok.webp",
            name: "tiktok",
            link: "https://www.tiktok.com/@sherifosama09?_t=8sW8eat3jAQ&_r=1",
        },
        {
            icon: "/images/footer/Instagram.webp",
            name: "instagram",
            link: "https://www.instagram.com/sherifosama14?igsh=OHhoc2RhbGQ3a3dk",
        },
        {
            icon: "/images/footer/Youtube.webp",
            name: "youtube",
            link: "https://m.youtube.com/@sherifosama6249?",
        },
        {
            icon: "/images/footer/Facebook.webp",
            name: "Facebook",
            link: "https://www.facebook.com/share/19ZAEBxw3e/?mibextid=wwXIfr",
        },
    ];

    return (
        <footer className="relative z-10">
            <img
                src="/images/footer/footerWave.webp"
                alt="footer wave design image"
                width="100%"
                loading="lazy"
                decoding="async"
            />
            <div className="flex flex-col justify-center items-center gap-4 w-100 bg-primary-color-primary h-[208px] py-10">
                <ul className="flex gap-1 md:gap-3">
                    {links.map((item) => (
                        <li key={item.name}>
                            <a
                                href={item.link}
                                target="_blank"
                                aria-label={`${item.name} link`}
                            >
                                <img
                                    src={item.icon}
                                    className="w-10 md:w-full"
                                    alt={`${item.name} link`}
                                    loading="lazy"
                                    decoding="async"
                                />
                            </a>
                        </li>
                    ))}
                </ul>
                <h2 className="text-sm text-white md:text-lg">
                    {" "}
                    منصة مستر شريف اسامه 2024 جميع الحقوق محفوظة &copy;
                </h2>
                <h3 className="text-sm text-white md:text-base">
                    Developed by:{" "}
                    <a
                        href="https://linktr.ee/DarkSemicolon"
                        target="_blank"
                        className="text-primary-color-light "
                    >
                        Darksemicolon
                    </a>
                </h3>
            </div>
        </footer>
    );
}

export default Footer;
